import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { CircularProgress, Box } from '@mui/material';
import NotFound from '../pages/NotFound';

interface UserRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const UserRoute: React.FC<UserRouteProps> = ({ children, adminOnly = false }) => {
  const { user, loading, isAuthenticated } = useAppSelector((state) => state.auth);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If route is admin-only and user is not admin, show NotFound
  const adminRoles = ['admin', 'anis-admin', 'superadmin'];
  if (adminOnly && (!user?.role || !adminRoles.includes(user.role))) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default UserRoute;